"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Input = _interopRequireDefault(require("../../Inputs/Input/Input"));

var _Button = _interopRequireDefault(require("../../Buttons/Button/Button"));

var _ParagraphText = _interopRequireDefault(require("../../TextElements/BasicTextElements/ParagraphText"));

var _RatingFeedback = require("./RatingFeedback.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Likert Feedback component
 */
var RatingFeedback = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RatingFeedback, _React$PureComponent);

  var _super = _createSuper(RatingFeedback);

  function RatingFeedback() {
    var _this;

    _classCallCheck(this, RatingFeedback);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "feedbackChangeHandler", function (e) {
      return _this.props.feedbackChangeHandler && _this.props.feedbackChangeHandler(e);
    });

    _defineProperty(_assertThisInitialized(_this), "feedbackSubmitHandler", function () {
      return _this.props.feedbackSubmitHandler && _this.props.feedbackSubmitHandler();
    });

    return _this;
  }

  _createClass(RatingFeedback, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          feedbackChangeHandler = _this$props.feedbackChangeHandler,
          feedbackFocus = _this$props.feedbackFocus,
          feedbackCharLimit = _this$props.feedbackCharLimit,
          feedbackSubmitHandler = _this$props.feedbackSubmitHandler,
          handleKeyUp = _this$props.handleKeyUp,
          isFeedbackSubmitted = _this$props.isFeedbackSubmitted,
          isRatingSelected = _this$props.isRatingSelected,
          props = _objectWithoutProperties(_this$props, ["className", "dataTestId", "feedbackChangeHandler", "feedbackFocus", "feedbackCharLimit", "feedbackSubmitHandler", "handleKeyUp", "isFeedbackSubmitted", "isRatingSelected"]);

      return /*#__PURE__*/_react.default.createElement(_RatingFeedback.StyledRatingFeedback, _extends({
        className: className,
        dataTestId: dataTestId
      }, props), isRatingSelected && !isFeedbackSubmitted && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        dataTestId: "rating-feedback-heading"
      }, "Thanks!"), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        dataTestId: "rating-feedback-question"
      }, "Why did you give us that score?"), /*#__PURE__*/_react.default.createElement(_Input.default, {
        autoFocus: feedbackFocus,
        className: "c-rating-feedback-input",
        dataTestId: "rating-feedback-input",
        onChange: this.feedbackChangeHandler,
        onKeyUp: handleKeyUp,
        value: this.props.feedback,
        characterLimit: feedbackCharLimit
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        onClick: this.feedbackSubmitHandler,
        dataTestId: "rating-feedback-button"
      }, "Send Feedback")), isFeedbackSubmitted && /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        className: "c-rating-feedback-response",
        dataTestId: "rating-feedback-response"
      }, "Your Feedback is on its way!"));
    }
  }]);

  return RatingFeedback;
}(_react.default.PureComponent);

_defineProperty(RatingFeedback, "propTypes", {
  /** Styling hook */
  className: _propTypes.PropTypes.string,

  /** Test ID hook */
  dataTestId: _propTypes.PropTypes.string.isRequired,

  /** Feedback String */
  feedback: _propTypes.PropTypes.string,

  /** Submit Handler */
  feedbackSubmitHandler: _propTypes.PropTypes.func.isRequired,

  /** Has the feedback has been submitted? */
  isFeedbackSubmitted: _propTypes.PropTypes.bool,

  /** Has the rating been submitted */
  isRatingSelected: _propTypes.PropTypes.bool,

  /** On feedback input change */
  feedbackChangeHandler: _propTypes.PropTypes.func.isRequired,

  /** Should feedback input have focus? */
  feedbackFocus: _propTypes.PropTypes.bool,

  /** Character limit for nps feedback input */
  feedbackCharLimit: _propTypes.PropTypes.number,

  /** Should feedback input have focus? */
  handleKeyUp: _propTypes.PropTypes.func
});

_defineProperty(RatingFeedback, "defaultProps", {
  className: '',
  feedback: '',
  feedbackFocus: false,
  feedbackCharLimit: 255,
  handleKeyUp: function handleKeyUp() {},
  isFeedbackSubmitted: false,
  isRatingSelected: false
});

var _default = RatingFeedback;
exports.default = _default;